import { Expose } from 'class-transformer';

export class VoucherRedeemDayOfWeekApiModel {
  @Expose()
  dayOfWeek: number;

  @Expose()
  flgDayRedeemable: boolean;
}
